/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react'
import { Upload, Button } from 'antd'
import {
  UploadOutlined,
  PlusOutlined,
  LoadingOutlined,
} from '@ant-design/icons'
import axios from "axios";
import { getBase64 } from '../helper';

export default function CustomUpload({
  value,
  onChange,
  description = '',
  type = 'image', //image, file
  //disabled = false,
  multiple = false,
  showUploadList= true,
  accept = '.png, .jpg, .jpeg, .jfif',
}) {

  const [loading, setLoading] = useState(false)
  const uploading = useRef(false)
  const uploadRef = useRef(null)

  const uploadFile = async (file) => {
    const uploadForm = new FormData();
      uploadForm.append("image_url", file);
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploadImage`,
        uploadForm
      );
      // support backend returning either plain string or { url }
      const url = result?.data?.url || result?.data;
      return url;
  };
  const getFileList = () => {
    if (!value) {
      return []
    }

    const isImageUrl = (url) => /\.(jpeg|jpg|png|gif|webp|svg|jfif)(\?.*)?$/i.test(url)

    const makeItem = (fileUrl) => {
      const name = fileUrl?.split('/')?.pop() || fileUrl
      const isImg = isImageUrl(fileUrl)
      const item = { uid: fileUrl, name: isImg ? `${name} (image)` : name, url: fileUrl }
      if (isImg) item.thumbUrl = fileUrl
      return item
    }

    return Array.isArray(value)
      ? value
          ?.filter((file) => file !== undefined)
          .map((file) => makeItem(file))
      : [makeItem(value)]

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

    const handleUpload = (_, fileList) => {
        if (uploading.current) {
        return
        }

        uploading.current = true

        setLoading(true)
        return new Promise((resolve, reject) => {
        Promise.all(
            fileList?.map(async (file) => {
            const action = uploadFile
            return action(file)
              .then((data) => {
              // action may return string URL or object {url}
              if (!data) return null
              return typeof data === 'string' ? data : (data.url || null)
              })
                .catch((err) => {
                reject(err)
                })
                .finally(() => setLoading(false))
            }),
        ).then((files) => {
            if (files?.[0]) {
            const newValues = multiple ? [...(value || []), ...files] : files?.[0]
            onChange && onChange(newValues)
            uploading.current = false
            resolve(newValues)
            }
        })
        })
    }

    const handlePreview = async (file) => {
    const isImageUrl = (url) => /\.(jpeg|jpg|png|gif|webp|svg|jfif)(\?.*)?$/i.test(url)

    if (file.url) {
      // if URL looks like an image open it directly, otherwise open in new tab
      return window.open(file.url, '_blank', 'noopener,noreferrer')
    }

    if (!file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj)
    }

    if (file.preview) {
      const w = window.open()
      if (w) {
        w.document.write(`<img src="${file.preview}" style="max-width:100%;height:auto;"/>`)
        w.document.title = file.name || 'Preview'
      }
    }
    }

  const handleRemove = (file) => {
    const newValues = multiple
      ? value.filter((url) => url !== file?.url)
      : null
    onChange && onChange(newValues)
  }

  const UploadButton = () => {
    return <div>{loading ? <LoadingOutlined /> : <PlusOutlined />}</div>
  }

  return (
    <>
      <Upload
        showUploadList={showUploadList}
        fileList={getFileList()}
        listType={type === 'image' ? 'picture-card' : 'text'}
        beforeUpload={handleUpload}
        onPreview={handlePreview}
        multiple={multiple}
        onRemove={(file) => handleRemove(file)}
        {...(accept && { accept })}
      >
        {type === 'image' ? (
          multiple ? (
            <UploadButton />
          ) : getFileList().length === 0 ? (
            <UploadButton />
          ) : null
        ) : (
          <div>
            <Button
              loading={loading}
              onClick={() => uploadRef.current?.click()}
              icon={<UploadOutlined />}
              style={{ marginTop: 6 }}
            >
              Upload File
            </Button>
            <div style={{ paddingTop: 4 }}>{description}</div>
          </div>
        )}
      </Upload>
    </>
  )
}
